import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export const TableSettingsDialogFooter = props => {
    const { hasChanged, isResetAll, immediateChange, resetButtonText, onHide, closeButtonText, cancelButtonText, applyButtonText, onResetColumnChanges, onConfirmResetColumnChanges, onCancelResetColumnChanges, onDiscardChanges, onApplyChanges, } = props;
    const restButtonClassNames = classNames('btn', 'btn-link', !hasChanged && 'disabled');
    return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: 'pull-left' }, { children: [!isResetAll && (_jsxs("div", Object.assign({ className: restButtonClassNames, onClick: onResetColumnChanges }, { children: [_jsx("span", { className: 'rioglyph rioglyph-revert text-size-xs margin-right-10' }), resetButtonText] }))), isResetAll && (_jsxs("div", Object.assign({ className: 'btn-group' }, { children: [_jsx("div", Object.assign({ className: 'btn btn-icon-only btn-default margin-right-5 btn-outline', onClick: onCancelResetColumnChanges }, { children: _jsx("span", { className: 'rioglyph rioglyph-remove' }) })), _jsx("div", Object.assign({ className: 'btn btn-primary btn-icon-only', onClick: onConfirmResetColumnChanges }, { children: _jsx("span", { className: 'rioglyph rioglyph-ok' }) }))] })))] })), immediateChange ? (_jsx("div", Object.assign({ className: 'pull-right' }, { children: _jsx("div", Object.assign({ className: 'btn btn-default', onClick: onHide }, { children: closeButtonText })) }))) : (_jsxs("div", Object.assign({ className: 'btn-toolbar pull-right' }, { children: [_jsx("div", Object.assign({ className: 'btn btn-default', onClick: onDiscardChanges }, { children: cancelButtonText })), _jsx("div", Object.assign({ className: 'btn btn-primary', onClick: onApplyChanges }, { children: applyButtonText }))] })))] }));
};
TableSettingsDialogFooter.defaultProps = {
    hasChanged: false,
    isResetAll: false,
    immediateChange: false,
    resetButtonText: '',
    closeButtonText: '',
    cancelButtonText: '',
    applyButtonText: '',
    onHide: () => undefined,
    onResetColumnChanges: () => undefined,
    onDiscardChanges: () => undefined,
    onApplyChanges: () => undefined,
};
TableSettingsDialogFooter.propTypes = {
    hasChanged: PropTypes.bool,
    isResetAll: PropTypes.bool,
    immediateChange: PropTypes.bool,
    resetButtonText: PropTypes.node,
    closeButtonText: PropTypes.node,
    cancelButtonText: PropTypes.node,
    applyButtonText: PropTypes.node,
    onHide: PropTypes.func,
    onResetColumnChanges: PropTypes.func,
    onDiscardChanges: PropTypes.func,
    onApplyChanges: PropTypes.func,
    onConfirmResetColumnChanges: PropTypes.func,
    onCancelResetColumnChanges: PropTypes.func,
};
